// enums for ui settings
export enum ProxyProfile {
  KEEP_CURRENT_SETTINGS = 1,
  ENABLE_PROXY = 2,
  DISABLE_PROXY = 3,
  AUTO_DETECT_PROXY = 4,
}
